import { render, staticRenderFns } from "./PartnersStats.vue?vue&type=template&id=4cce6a54&"
import script from "./PartnersStats.vue?vue&type=script&lang=js&"
export * from "./PartnersStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cce6a54')) {
      api.createRecord('4cce6a54', component.options)
    } else {
      api.reload('4cce6a54', component.options)
    }
    module.hot.accept("./PartnersStats.vue?vue&type=template&id=4cce6a54&", function () {
      api.rerender('4cce6a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/PartnersStats.vue"
export default component.exports